import React from "react";
import classnames from "classnames";
import { NavLink } from "react-router-dom";

class NavbarLinkItem extends React.Component {
  render() {
    let dispalySpan = "";
    if (this.props.navbarBadgeDisplay && this.props.navbarbasketCount > 0) {
      dispalySpan = (
        <span className="position-absolute bg-danger rounded-pill count-basket text-white">
          {this.props.navbarbasketCount}
        </span>
      );
    }
    return (
      <>
        <NavLink
          onClick={this.props.closeCollapse}
          exact={this.props.exactLink}
          className={classnames(
            "col nav-link text-center",
            this.props.styleNameClass
          )}
          to={this.props.navbarItemHref}
          activeclassname="active-link"
        >
          {dispalySpan}
          {this.props.navbarItemIcon}
          <span className="d-block pt-1">{this.props.navbarItemTitle}</span>
        </NavLink>
      </>
    );
  }
}
export default NavbarLinkItem;
